export const state = {
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  leftSidebarType: 'colored',
  topbar: 'dark',
  loader: false,
  isMenuClosed: false,
}

export const mutations = {
  CHANGE_LAYOUT (state, layoutType) {
    state.layoutType = layoutType
  },
  CHANGE_LAYOUT_WIDTH (state, layoutWidth) {
    state.layoutWidth = layoutWidth
  },
  CHANGE_LEFT_SIDEBAR_TYPE (state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType
  },
  CHANGE_TOPBAR (state, topbar) {
    state.topbar = topbar
  },
  LOADER (state, loader) {
    state.loader = loader
  },
  SET_ISMENUCLOSED(state, payload) {
    state.isMenuClosed = payload
  },
}

export const actions = {
  changeLayoutType ({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType)
  },

  changeLayoutWidth ({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
  },

  changeLeftSidebarType ({ commit }, { leftSidebarType }) {
    commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
  },

  changeTopbar ({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar)
  },

  changeLoaderValue ({ commit }, { loader }) {
    commit('LOADER', loader)
  },

  setIsMenuClosed ({ commit }, payload) {
    commit('SET_ISMENUCLOSED', payload)
  },

  toggleMenu({ commit }, payload) {
    if (payload === false) {
      document.body.classList.remove('sidebar-enable')
      document.body.classList.remove('vertical-collpsed')
      document.querySelectorAll('.notif-badge-sidenav').forEach((el) => {
        el.classList.add('d-none')
        el.classList.remove('notif-circle-sidebar')
      })
    } else {
      document.querySelectorAll('.notif-badge-sidenav').forEach((el) => {
        el.classList.remove('d-none')
        el.classList.add('notif-circle-sidebar')
      })
      document.body.classList.add('sidebar-enable')

      if (window.screen.width >= 992) {
        document.body.classList.add('vertical-collpsed')
      }
    }

    commit('SET_ISMENUCLOSED', payload)
  }
}
